export * from './domain';
export * from './testkit';
export * from './builders';
export * from './dto';
export var createControlRoomApi = function (baseUrl, http) {
    var url = "".concat(baseUrl, "/controlRoom");
    return {
        getAgentsTable: function (dto) { return http.post("".concat(url, "/dashboard"), dto); },
        getAgentFullStats: function (agentId) { return http.get("".concat(url, "/").concat(agentId), {}); },
    };
};
//# sourceMappingURL=index.js.map